export default __webpack_public_path__ + "img/arrow_right.01978df7.svg";